<template>
  <div class="two-container">
    <!-- <div class="little-title"></div> -->
    <div class="model-six">
      <div class="top-info">
        <div class="item-1">
          <img :src=" $theme ? lightLogo : lightLogoEng" alt="">
          <div class="text">{{$theme ? "联系我们" : "Contact Us"}} </div>
          <div class="phone-num">（010）88580888</div>
          <div class="email">{{$theme ? "邮箱" : "Email"}}：marketing@chinaentropy.com</div>
          <div v-if="$theme" class="address">北京·朝阳：利泽中二路101号,望京科技园A座6层</div>
          <div v-if="$theme" class="address">深圳·福田：中康路136号深圳新一代产业园3栋1504-1</div>
          <div v-if="$theme" class="address">深圳·龙岗：龙岗中心城腾飞路9号,龙岗创投大厦34层</div>
          <div v-if="$theme" class="address">河北·张家口：经开区凤凰城2期27号楼4层</div>
        </div>
        <div class="item-2 list" :class="{'item-eng-2': !$theme}">
          <div class="title">{{$theme ? "关于汉熵" : "ABOUT US"}}</div>
          <div class="one-item">{{$theme ? "公司简介" : "Introduction"}}</div>
          <div class="one-item">{{$theme ? "品牌荣誉" : "Honor"}}</div>
          <div class="one-item">{{$theme ? "加入我们" : "Jobs"}}</div>
        </div>
        <div class="item-3 list" :class="{'item-eng-1': !$theme}">
          
          <div class="title">{{$theme ? "解决方案" : "SOLUTIONS"}}</div>
          <div class="one-item">{{$theme ? "智慧林草" : "Smart Forestry and Grassland"}}</div>
          <div class="one-item">{{$theme ? "智慧碳汇" : "Smart Carbon Sequestration"}}</div>
          <div class="one-item">{{$theme ? "仓储物流" : "Warehousing and Logistics"}}</div>
          <div class="one-item">{{$theme ? "智慧环保" : "Smart Environmental Protection"}}</div>
          <div class="one-item">{{$theme ? "城市治理" : "Urban Governance"}}</div>
          <div class="one-item">{{$theme ? "智慧应急" : "Smart Emergency"}}</div>
          <div class="one-item">{{$theme ? "智慧公安" : "Smart Public Security"}}</div>
          <div class="one-item">{{$theme ? "智慧校园" : "Smart Campus"}}</div>
        </div>
        <div class="item-4 list" :class="{'item-eng-2': !$theme}">
          <div class="title">{{$theme ? "产品中心" : "PRODUCTS"}}</div>
          <div class="one-item">{{$theme ? "软件产品" : "Software Products"}}</div>
          <div class="one-item">{{$theme ? "硬件产品" : "Hardware Products"}}</div>
        </div>
        <div class="item-5 list" :class="{'item-eng-2': !$theme}">
          <div class="title">{{$theme ? "加入我们" : "JOBS"}}</div>
          <div class="one-item">{{$theme ? "社会招聘" : "Social Recruitment"}}</div>
          <div class="one-item">{{$theme ? "校园招聘" : "Campus Recruitment"}}</div>
        </div>
      </div>
      <div class="line"></div>
      <div class="bottom-info">
        Copyright ® 2025 Designed and Developed by China Entropy Co., Ltd. . All Rights Reserved.
    
      </div>
    </div>
  </div>
</template>

<script>
import lightLogo from "/static/image/logo.png";
import lightLogoEng from "/static/image/logo-eng.png";
import totop from "/static/image/home/to-top.png";
export default {
  data() {
    return {
      lightLogo,
      lightLogoEng,
      totop,
      menuList: [
        {
          name: "首页",
          enName: "HOME",
          name2: "HOME",
          enName2: "OUR SUMMARY",
          url: "/",
        },
        {
          name: "解决方案",
          enName: "OUR SOLUTION",
          name2: "Cases",
          enName2: "OUR WORK",
          url: "/solution",
        },
        {
          name: "产品中心",
          enName: "OUR PRODUCT",
          name2: "Products",
          enName2: "WHAT WE DO",
          url: "/product-center",
        },
        {
          name: "品牌荣誉",
          enName: "HONOR",
          name2: "Honors ",
          enName2: "WHAT WE GET",
          url: "/brand-honor",
        },
        {
          name: "关于汉熵",
          enName: "ABOUT US",
          name2: "Company",
          enName2: "ABOUT US",
          url: "/on-china-entropy",
        },
        {
          name: "加入我们",
          enName: "JOBS",
          name2: "Careers",
          enName2: "JOBS",
          url: "/join-us",
        },
      ],
    };
  },
  props: {},
  components: {
  },
  computed: {},
  methods: {
    initBgAnimal() {
      const canvas = document.getElementById("particleCanvas");
      const ctx = canvas.getContext("2d");

      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      class Particle {
        constructor() {
          this.x = Math.random() * canvas.width;
          this.y = Math.random() * canvas.height;
          this.size = Math.random() * 0 + 1;
          this.speedX = (Math.random() - 0.5) * 3;
          this.speedY = (Math.random() - 0.5) * 4;
        }

        draw() {
          ctx.fillStyle = "rgba(255,255,255, 0.3)";
          ctx.strokeStyle = "rgba(173,216,230, 0.8)";
          ctx.lineWidth = 2;
          ctx.beginPath();
          ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
          ctx.closePath();
          ctx.fill();
        }

        update() {
          this.x += this.speedX;
          this.y += this.speedY;

          if (
            this.x < 0 ||
            this.x > canvas.width ||
            this.y < 0 ||
            this.y > canvas.height
          ) {
            this.x = Math.random() * canvas.width;
            this.y = Math.random() * canvas.height;
          }
        }
      }

      const particles = [];

      for (let i = 0; i < 5000; i++) {
        particles.push(new Particle());
      }

      function animate() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        for (let i = 0; i < particles.length; i++) {
          particles[i].draw();
          particles[i].update();
        }

        requestAnimationFrame(animate);
      }
      animate();
    },
    initTextAnimal() {
      const COLOR = "#fff"; // 设定粒子特效颜色
      let MESSAGE = document.getElementById("ChangeText").textContent; // 根据标签的ID获取待处理的文字内容

      let FONT_SIZE = 42 || window.innerWidth * 0.08; // 字体大小
      let AMOUNT = 4000; // 设定粒子数量
      let SIZE = 1; // 粒子大小
      let INITIAL_DISPLACEMENT = 500; // 最初位移量
      const INITIAL_VELOCITY = 7.5; // 最初速度
      const VELOCITY_RETENTION = 0.95; // 速度保持
      let SETTLE_SPEED = 1; // 稳定速度
      const FLEE_SPEED = 2; // 逃逸速度
      const FLEE_DISTANCE = 50; // 逃逸距离
      let FLEE = true; // 逃逸模式
      let SCATTER_VELOCITY = 3; // 散射速度
      const SCATTER = false; // 散射模式

      // 若处于移动设备展示
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        // Mobile
        MESSAGE = document.getElementById("ChangeText").textContent; // 通过标签ID获取文本内容

        FONT_SIZE = 50; // 字体大小减小
        AMOUNT = 300; // 粒子数量减少
        SIZE = 2;
        INITIAL_DISPLACEMENT = 100; // 最初位移量减少
        SETTLE_SPEED = 1; // 最初速度减少
        FLEE = false; // 关闭逃逸模式
        SCATTER_VELOCITY = 2; // 散射速度
      }

      const canvas = document.getElementById("ChangeText");
      const ctx = canvas.getContext("2d"); // 创建画布

      let POINTS = [];
      const MOUSE = {
        x: 0,
        y: 0,
      };

      function Point(x, y, r, g, b, a) {
        const angle = Math.random() * 6.28;
        this.x =
          canvas.width / 2 - x + (Math.random() - 0.5) * INITIAL_DISPLACEMENT;
        this.y =
          canvas.height / 2 - y + (Math.random() - 0.5) * INITIAL_DISPLACEMENT;
        this.velx = INITIAL_VELOCITY * Math.cos(angle);
        this.vely = INITIAL_VELOCITY * Math.sin(angle);
        this.target_x = canvas.width / 2 - x;
        this.target_y = canvas.height / 2 - y;
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;

        this.getX = function () {
          return this.x;
        };

        this.getY = function () {
          return this.y;
        };
        this.fleeFrom = function () {
          this.velx -= ((MOUSE.x - this.x) * FLEE_SPEED) / 10;
          this.vely -= ((MOUSE.y - this.y) * FLEE_SPEED) / 10;
        };

        this.settleTo = function () {
          this.velx += ((this.target_x - this.x) * SETTLE_SPEED) / 100;
          this.vely += ((this.target_y - this.y) * SETTLE_SPEED) / 100;
          this.velx -= this.velx * (1 - VELOCITY_RETENTION);
          this.vely -= this.vely * (1 - VELOCITY_RETENTION);
        };

        this.scatter = function () {
          const unit = this.unitVecToMouse();
          const vel = SCATTER_VELOCITY * 10 * (0.5 + Math.random() / 2);
          this.velx = -unit.x * vel;
          this.vely = -unit.y * vel;
        };

        this.move = function () {
          if (this.distanceToMouse() <= FLEE_DISTANCE) {
            this.fleeFrom();
          } else {
            this.settleTo();
          }

          if (this.x + this.velx < 0 || this.x + this.velx >= canvas.width) {
            this.velx *= -1;
          }
          if (this.y + this.vely < 0 || this.y + this.vely >= canvas.height) {
            this.vely *= -1;
          }

          this.x += this.velx;
          this.y += this.vely;
        };
        this.distanceToMouse = function () {
          return this.distanceTo(MOUSE.x, MOUSE.y);
        };

        this.distanceTo = function (x, y) {
          return Math.sqrt(
            (x - this.x) * (x - this.x) + (y - this.y) * (y - this.y)
          );
        };
        this.unitVecToMouse = function () {
          return this.unitVecTo(MOUSE.x, MOUSE.y);
        };

        this.unitVecTo = function (x, y) {
          const dx = x - this.x;
          const dy = y - this.y;
          return {
            x: dx / Math.sqrt(dx * dx + dy * dy),
            y: dy / Math.sqrt(dx * dx + dy * dy),
          };
        };
      }

      window.addEventListener("resize", function () {
        resizeCanvas();
        adjustText();
      });

      if (FLEE) {
        window.addEventListener("mousemove", function (event) {
          MOUSE.x = event.clientX;
          MOUSE.y = event.clientY;
        });
      }

      if (SCATTER) {
        window.addEventListener("click", function (event) {
          MOUSE.x = event.clientX;
          MOUSE.y = event.clientY;
          for (let i = 0; i < POINTS.length; i++) {
            POINTS[i].scatter();
          }
        });
      }

      function resizeCanvas() {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      }

      function adjustText() {
        ctx.fillStyle = COLOR;
        ctx.textBaseline = "middle";
        ctx.textAlign = "center";
        ctx.font = FONT_SIZE + "px SourceHanSansCN-Bold";
        ctx.fillText(MESSAGE, canvas.width / 2, canvas.height / 2);
        const textWidth = ctx.measureText(MESSAGE).width;
        if (textWidth === 0) {
          return;
        }
        const minX = canvas.width / 2 - textWidth / 2;
        const minY = canvas.height / 2 - FONT_SIZE / 2;
        const data = ctx.getImageData(minX, minY, textWidth, FONT_SIZE).data;
        let isBlank = true;
        for (let i = 0; i < data.length; i++) {
          if (data[i] !== 0) {
            isBlank = false;
            break;
          }
        }

        if (!isBlank) {
          let count = 0;
          let curr = 0;
          let num = 0;
          let x = 0;
          let y = 0;
          const w = Math.floor(textWidth);
          POINTS = [];
          while (count < AMOUNT) {
            while (curr === 0) {
              num = Math.floor(Math.random() * data.length);
              curr = data[num];
            }
            num = Math.floor(num / 4);
            x = w / 2 - (num % w);
            y = FONT_SIZE / 2 - Math.floor(num / w);
            POINTS.push(
              new Point(
                x,
                y,
                data[num * 4],
                data[num * 4 + 1],
                data[num * 4 + 2],
                data[num * 4 + 3]
              )
            );
            curr = 0;
            count++;
          }
        }
      }

      function init() {
        resizeCanvas();
        adjustText();
        window.requestAnimationFrame(animate);
      }

      function animate() {
        update();
        draw();
      }

      function update() {
        let point;
        for (let i = 0; i < POINTS.length; i++) {
          point = POINTS[i];
          point.move();
        }
      }

      function draw() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        let point;
        for (let i = 0; i < POINTS.length; i++) {
          point = POINTS[i];
          ctx.fillStyle =
            "rgba(" +
            point.r +
            "," +
            point.g +
            "," +
            point.b +
            "," +
            point.a +
            ")";
          ctx.beginPath();
          ctx.arc(point.getX(), point.getY(), SIZE, 0, 2 * Math.PI);
          ctx.fill();
        }

        window.requestAnimationFrame(animate);
      }

      init();
    },
    changeMenu(item){
      this.$router.push(item.url);
    },
  },
  created() {},
  mounted() {
    // this.initBgAnimal();
    // this.initTextAnimal();
  },
  watch: {},
};
</script>

<style scoped lang="scss">
@import "./Index.scss";
</style>
